export default __webpack_public_path__ + "static/media/2.1-Lamination.bde501e2.jpg";